import { render, staticRenderFns } from "./TerminalAuthorizationList.vue?vue&type=template&id=8ee9bb74&scoped=true&"
import script from "./TerminalAuthorizationList.vue?vue&type=script&lang=js&"
export * from "./TerminalAuthorizationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee9bb74",
  null
  
)

export default component.exports